"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/headerSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { LanguageSelector, SmartImage, SmartLink } from "@/Components";
import { useResponsive } from "@/Hooks";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeaderSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Monday - Friday : 8:30 AM to 6:30 PM" | "+1 80001 54569" */
    pText: ReactNode;
    /** Detected variants: "isax isax-clock me-1" | "isax isax-call me-1" */
    className: string;
};

type HeaderSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "ENG" | "ARA" | "FRA" */
    link0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/flags/us-flag.svg" | "/Templates/Doccure/img/flags/arab-flag.svg" | "/Templates/Doccure/img/flags/france-flag.svg" */
    src: string;
    /** Detected variants: "dropdown-item rounded d-flex align-items-center" */
    className?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "flag" */
    alt?: string;
    /** Detected variants: "me-2" */
    imageWithBasePath0ClassName?: string;
};
export type HomeSevenHeaderSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLAnchorElement>;
    /** Default: false */
    divDiv0Div0Div0Ul0Li0Div0Link0LinkAriaExpanded?: boolean;
    /** Default: "dropdown" */
    divDiv0Div0Div0Ul0Li0Div0Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    divDiv0Div0Div0Ul0Li0Div0Link0LinkHref?: string;
    /** Default: "ENG" */
    divDiv0Div0Div0Ul0Li0Div0Link0LinkText?: ReactNode;
    /** Default: "#" */
    divHeader0Div0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    divHeader0Div0Nav0Div0Link0LinkId?: string;
    divHeader0Div0Nav0Div0Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home7" */
    divHeader0Div0Nav0Div0Link1LinkHref?: string;
    divHeader0Div0Nav0Div0Link1LinkVisible?: boolean;
    divHeader0Div0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-white-02.svg" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-07.svg" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageSrc?: string;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageVisible?: boolean;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.home7" */
    divHeader0Div0Nav0Div1Div0Link0LinkHref?: string;
    divHeader0Div0Nav0Div1Div0Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-07.svg" */
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc?: string;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    divHeader0Div0Nav0Div1Div0Link1LinkHref?: string;
    /** Default: "menu_close" */
    divHeader0Div0Nav0Div1Div0Link1LinkId?: string;
    divHeader0Div0Nav0Div1Div0Link1LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "search_popup" */
    divHeader0Div0Nav0Ul0Li0Link0LinkAriaControls?: string;
    /** Default: "#search_popup" */
    divHeader0Div0Nav0Ul0Li0Link0LinkDataBsTarget?: string;
    /** Default: "offcanvas" */
    divHeader0Div0Nav0Ul0Li0Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    divHeader0Div0Nav0Ul0Li0Link0LinkHref?: string;
    divHeader0Div0Nav0Ul0Li0Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Ul0Li0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Ul0Li0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.booking" */
    divHeader0Div0Nav0Ul0Li1Link0LinkHref?: string;
    divHeader0Div0Nav0Ul0Li1Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Ul0Li1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Ul0Li1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Book Appointment" */
    divHeader0Div0Nav0Ul0Li1Link0Span0SpanText?: ReactNode;
    /** Default: "#support_item" */
    divHeader0Div0Nav0Ul0Li2Link0LinkDataBsTarget?: string;
    /** Default: "offcanvas" */
    divHeader0Div0Nav0Ul0Li2Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    divHeader0Div0Nav0Ul0Li2Link0LinkHref?: string;
    divHeader0Div0Nav0Ul0Li2Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Ul0Li2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Ul0Li2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    headerSectionDivs: HeaderSectionDivsItem[];
    headerSectionUls: HeaderSectionUlsItem[];
    headerSectionDivsItemWrapper?: (item: HeaderSectionDivsItem, content: ReactNode) => ReactNode;
    headerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUlsItemWrapper?: (item: HeaderSectionUlsItem, content: ReactNode) => ReactNode;
    headerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSevenHeaderSectionGenerated: FC<HomeSevenHeaderSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    divDiv0Div0Div0Ul0Li0Div0Link0LinkAriaExpanded = false,
    divDiv0Div0Div0Ul0Li0Div0Link0LinkDataBsToggle = "dropdown",
    divDiv0Div0Div0Ul0Li0Div0Link0LinkHref = "#",
    divDiv0Div0Div0Ul0Li0Div0Link0LinkText = "ENG",
    divHeader0Div0Nav0Div0Link0LinkHref = "#",
    divHeader0Div0Nav0Div0Link0LinkId = "mobile_btn",
    divHeader0Div0Nav0Div0Link0LinkVisible,
    divHeader0Div0Nav0Div0Link0LinkRenderer,
    divHeader0Div0Nav0Div0Link0LinkProps,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-white-02.svg",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageAlt = "Logo",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/logo-07.svg",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageVisible,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageRenderer,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageProps,
    divHeader0Div0Nav0Div0Link1LinkHref = "all_routes.home7",
    divHeader0Div0Nav0Div0Link1LinkVisible,
    divHeader0Div0Nav0Div0Link1LinkRenderer,
    divHeader0Div0Nav0Div0Link1LinkProps,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-07.svg",
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps,
    divHeader0Div0Nav0Div1Div0Link0LinkHref = "all_routes.home7",
    divHeader0Div0Nav0Div1Div0Link0LinkVisible,
    divHeader0Div0Nav0Div1Div0Link0LinkRenderer,
    divHeader0Div0Nav0Div1Div0Link0LinkProps,
    divHeader0Div0Nav0Div1Div0Link1LinkHref = "#",
    divHeader0Div0Nav0Div1Div0Link1LinkId = "menu_close",
    divHeader0Div0Nav0Div1Div0Link1LinkVisible,
    divHeader0Div0Nav0Div1Div0Link1LinkRenderer,
    divHeader0Div0Nav0Div1Div0Link1LinkProps,
    divHeader0Div0Nav0Ul0Li0Link0LinkAriaControls = "search_popup",
    divHeader0Div0Nav0Ul0Li0Link0LinkDataBsTarget = "#search_popup",
    divHeader0Div0Nav0Ul0Li0Link0LinkDataBsToggle = "offcanvas",
    divHeader0Div0Nav0Ul0Li0Link0LinkHref = "#",
    divHeader0Div0Nav0Ul0Li0Link0LinkVisible,
    divHeader0Div0Nav0Ul0Li0Link0LinkRenderer,
    divHeader0Div0Nav0Ul0Li0Link0LinkProps,
    divHeader0Div0Nav0Ul0Li1Link0LinkHref = "all_routes.booking",
    divHeader0Div0Nav0Ul0Li1Link0LinkVisible,
    divHeader0Div0Nav0Ul0Li1Link0LinkRenderer,
    divHeader0Div0Nav0Ul0Li1Link0LinkProps,
    divHeader0Div0Nav0Ul0Li1Link0Span0SpanText = "Book Appointment",
    divHeader0Div0Nav0Ul0Li2Link0LinkDataBsTarget = "#support_item",
    divHeader0Div0Nav0Ul0Li2Link0LinkDataBsToggle = "offcanvas",
    divHeader0Div0Nav0Ul0Li2Link0LinkHref = "#",
    divHeader0Div0Nav0Ul0Li2Link0LinkVisible,
    divHeader0Div0Nav0Ul0Li2Link0LinkRenderer,
    divHeader0Div0Nav0Ul0Li2Link0LinkProps,
    headerSectionDivs,
    headerSectionUls,
    headerSectionDivsItemWrapper,
    headerSectionDivsRenderer,
    headerSectionUlsItemWrapper,
    headerSectionUlsRenderer,
}) => {
    const { isMobile } = useResponsive();
    return (
        <div className="main-header">
            <div className="header-topbar header-topbar-seven">
                <div className="container">
                    <div className="topbar-info">
                        <div className="header-info">
                            {renderCollectionNode(
                                headerSectionDivs,
                                (item: HeaderSectionDivsItem) => (
                                    <p key={item.key}>
                                        <i className={item.className} />
                                        {item.pText}
                                    </p>
                                ),
                                headerSectionDivsItemWrapper,
                                headerSectionDivsRenderer
                            )}
                        </div>
                        <ul>
                            <li className="drop-header">
                                <LanguageSelector iconOnly={isMobile} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <header className={isScrolled ? "header header-seven home-menu-seven fixed" : "header header-seven home-menu-seven"}>
                <div className="container">
                    <nav className="navbar navbar-expand-lg header-nav">
                        <div className="navbar-header">
                            {renderNode(divHeader0Div0Nav0Div0Link0LinkVisible, divHeader0Div0Nav0Div0Link0LinkRenderer, (
                                <SmartLink id={divHeader0Div0Nav0Div0Link0LinkId} href={divHeader0Div0Nav0Div0Link0LinkHref} onClick={onMobileBtn} {...(divHeader0Div0Nav0Div0Link0LinkProps ?? {})}>
                                    <i className="fa-solid fa-bars" />
                                </SmartLink>
                            ))}
                            {renderNode(divHeader0Div0Nav0Div0Link1LinkVisible, divHeader0Div0Nav0Div0Link1LinkRenderer, (
                                <SmartLink href={divHeader0Div0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(divHeader0Div0Nav0Div0Link1LinkProps ?? {})}>
                                    {renderNode(divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible, divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid white-logo" alt={divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    {renderNode(divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageVisible, divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageRenderer, (
                                        <SmartImage src={divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageSrc} className="img-fluid normal-logo" alt={divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageAlt} {...(divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageProps ?? {})} />
                                    ))}
                                </SmartLink>
                            ))}
                        </div>
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                {renderNode(divHeader0Div0Nav0Div1Div0Link0LinkVisible, divHeader0Div0Nav0Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Div1Div0Link0LinkHref} className="menu-logo" {...(divHeader0Div0Nav0Div1Div0Link0LinkProps ?? {})}>
                                        {renderNode(divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible, divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt} {...(divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </SmartLink>
                                ))}
                                {renderNode(divHeader0Div0Nav0Div1Div0Link1LinkVisible, divHeader0Div0Nav0Div1Div0Link1LinkRenderer, (
                                    <SmartLink id={divHeader0Div0Nav0Div1Div0Link1LinkId} className="menu-close" href={divHeader0Div0Nav0Div1Div0Link1LinkHref} onClick={onMenuClose} {...(divHeader0Div0Nav0Div1Div0Link1LinkProps ?? {})}>
                                        <i className="fas fa-times" />
                                    </SmartLink>
                                ))}
                            </div>
                            <HeaderNav menus={menus} />
                        </div>
                        <ul className="nav header-navbar-rht">
                            <li>
                                {renderNode(divHeader0Div0Nav0Ul0Li0Link0LinkVisible, divHeader0Div0Nav0Ul0Li0Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Ul0Li0Link0LinkHref} className="search-btn" tabIndex={-1} data-bs-toggle={divHeader0Div0Nav0Ul0Li0Link0LinkDataBsToggle} data-bs-target={divHeader0Div0Nav0Ul0Li0Link0LinkDataBsTarget} aria-controls={divHeader0Div0Nav0Ul0Li0Link0LinkAriaControls} {...(divHeader0Div0Nav0Ul0Li0Link0LinkProps ?? {})}>
                                        <i className="isax isax-search-normal-1" />
                                    </SmartLink>
                                ))}
                            </li>
                            <li>
                                {renderNode(divHeader0Div0Nav0Ul0Li1Link0LinkVisible, divHeader0Div0Nav0Ul0Li1Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Ul0Li1Link0LinkHref} className="btn btn-primary theme-7-btn" {...(divHeader0Div0Nav0Ul0Li1Link0LinkProps ?? {})}>
                                        <span>{divHeader0Div0Nav0Ul0Li1Link0Span0SpanText}</span>
                                        <span className="icon">
                                            <i className="isax isax-arrow-right-3" />
                                        </span>
                                    </SmartLink>
                                ))}
                            </li>
                            <li>
                                {renderNode(divHeader0Div0Nav0Ul0Li2Link0LinkVisible, divHeader0Div0Nav0Ul0Li2Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Ul0Li2Link0LinkHref} className="details-btn" data-bs-toggle={divHeader0Div0Nav0Ul0Li2Link0LinkDataBsToggle} data-bs-target={divHeader0Div0Nav0Ul0Li2Link0LinkDataBsTarget} {...(divHeader0Div0Nav0Ul0Li2Link0LinkProps ?? {})}>
                                        <i className="isax isax-menu" />
                                    </SmartLink>
                                ))}
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        </div>
    );
};

export default HomeSevenHeaderSectionGenerated;
